module.exports = __webpack_public_path__ + "static/bottom-bc2db8faf71d302979f2e0f6931e8de8.png";